module.exports = __webpack_public_path__ + "media/app/images/typeform-bd5690d95ca98e2d33630524a4fc9172.png";